module.exports = __webpack_public_path__ + "img/netherlands.ebcd669e.svg";